import { Component, ElementRef, inject, Input, OnDestroy } from '@angular/core';
import { EventsService } from 'app/services/events/events.service';

@Component({
    selector: 'app-add-term-banner',
    templateUrl: './add-term-banner.component.html',
    styleUrl: './add-term-banner.component.scss',
    standalone: false
})
export class AddTermBannerComponent {
  eventsService: EventsService = inject(EventsService);
  initialized: boolean = false;
  timeoutId: any;

  constructor() {
    this.showBanner = false; // Initialize showBanner to false
    this.eventsService.getShowBannerEvent().subscribe((multipleTerms: boolean) => {
      if(multipleTerms) {
        this.message = 'Terms added to advanced search page.';
      } else {
        this.message = 'Term added to advanced search page.'; 
      }
      this.openBanner();
    });
    this.initialized = true; // Set initialized to true after the constructor is called
  }
  
  @Input() message: string = 'Term added to advanced search page.';
  @Input() showBanner: boolean = false;

  openBanner(): void {
    if (this.initialized) {
      this.showBanner = true; // Set showBanner to true to display the banner
      this.timeoutId = setTimeout(() => {
            this.showBanner = false;
      }, 3500); // Automatically close the banner after 3.5 seconds 3500
    }
  }

  closeBanner(): void {
    clearTimeout(this.timeoutId); // Clear the timeout if it exists
    this.showBanner = false;
  }
}
